import { FormControl, FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { useDRPContext } from "../context";
import { DateRangePickerViews } from "../types";

export const DRPRadio = () => {
  const { selectedView, setSelectedView, views, handleRangeChange } = useDRPContext();

  if (!views || Object.keys(views).length < 2) {
    return null;
  }

  return (
    <Stack
      sx={{
        width: "100%",
        alignItems: "center",
      }}
    >
      <FormControl>
        <RadioGroup
          row
          aria-labelledby="radio-group-drp"
          defaultValue={selectedView}
          value={selectedView}
          onChange={(_, value) => {
            setSelectedView(value as DateRangePickerViews);
            handleRangeChange({ startDate: null, endDate: null });
          }}
          name="radio-buttons-group-drp"
          sx={{ gap: 4 }}
        >
          {views?.day && (
            <FormControlLabel
              value={DateRangePickerViews.DAY}
              control={<Radio size="small" sx={{ p: 0, pr: 1 }} />}
              label="Jour"
            />
          )}
          {views?.month && (
            <FormControlLabel
              value={DateRangePickerViews.MONTH}
              control={<Radio size="small" sx={{ p: 0, pr: 1 }} />}
              label="Mois"
            />
          )}
          {views?.year && (
            <FormControlLabel
              value={DateRangePickerViews.YEAR}
              control={<Radio size="small" sx={{ p: 0, pr: 1 }} />}
              label="Année"
            />
          )}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
};
